import { ConditionalRender } from '@medeloop/medeloop-components-library';
import { useParams } from 'react-router-dom';
import { useGetDataSourceById } from 'src/api/data-sources-queries';
import { capitalizeFirstLetter } from 'src/utils/datasets';
import DistributionChart from '../charts/distribution-chart';
import { GraphSkeleton } from '../charts/graph-skeleton';
import { useMemo } from 'react';
import { DataSourceWiki } from 'src/api/data-sources';

export const Highlights = () => {
  const { datasetId } = useParams();

  const { data: dataSource, isLoading } = useGetDataSourceById(datasetId ?? '');

  const localDataSourceWiki = useMemo(
    () => (dataSource?.dataWiki || {}) as DataSourceWiki,
    [dataSource],
  );

  return (
    <ConditionalRender
      assertion={!isLoading}
      fallback={
        <h2 className="font-semibold text-gray-100">
          <GraphSkeleton />
        </h2>
      }
    >
      <section className="grid grid-cols-2 gap-4">
        {localDataSourceWiki?.metadata?.highlights?.map((highlight, index) => (
          <div
            key={`$highlight-${index}`}
            className="bg-background-dark-subdued rounded-lg border border-stroke-on-dark-subdued"
          >
            <DistributionChart
              title={highlight.metric
                .split('_')
                .map((word) => capitalizeFirstLetter(word))
                .join(' ')}
              xAxisName={highlight.metric}
              yAxisName="Subjects (n)"
              data={(
                Object.entries(highlight.distribution || {})
                  .filter(([key, _]) => key !== 'null')
                  .map(([key, value]) => ({ label: key, value })) || []
              ).filter((_, idx) => idx < 5)}
              barsTouching={false}
              isCategorical={true}
              startColor="#67E8F9"
              endColor="#164E63"
              showXAxisName={false}
              sortBars={true}
              useKMBFormat={true}
              bottomMargin={50}
              rotateXAxisTicks={true}
            />
          </div>
        ))}
      </section>
    </ConditionalRender>
  );
};
